import { isDevOrPreviewSite } from '../../utils/general'
import { F_API_KEY, F_CUSTOM_DOMAIN, F_EDIT_MODE, F_EMAIL_GATE, F_PWD_PROTECTION } from './constants'

const isDev = isDevOrPreviewSite()

const API_PLAN = {
  id: isDev ? 'prod_RDXa0qtUpaMAcL' : 'prod_RF4v0SrJzdH7IS',
  label: 'API',
  // US-only plan: no eur/gbp/inr stripe entries, no payPro (India-only provider)
  prices: {
    yearly: {
      stripe: {
        usd: {
          symbol: '$',
          value: 888,
          priceId: isDev ? 'price_1QL6WuKnX1nnNv6IgkSO9BbK' : 'price_1QMaluKnX1nnNv6INKfC4hvP'
        }
      },
      // Paddle checkout for the API plan has never been wired up in prod; PaymentTabs hides this tab for it
      paddle: { priceId: isDev ? 'pri_01kb25s4ervqgmthjyamtc9pdd' : null }
    },
    monthly: {
      stripe: {
        usd: {
          symbol: '$',
          value: 99,
          priceId: isDev ? 'price_1QL6VkKnX1nnNv6I2Hu2tpbS' : 'price_1QMaluKnX1nnNv6IRARwQksc'
        }
      },
      paddle: { priceId: isDev ? 'pri_01kb25qkhqr77n74xrfepn47gf' : null }
    }
  },
  fileSizeLimit: 75,
  customDomainsLimit: 5,
  projectLimit: 999,
  accountLimit: 10000,
  visitorLimit: 500000,
  bandwidthLimit: 100,
  features: {
    [F_CUSTOM_DOMAIN]: true,
    [F_PWD_PROTECTION]: true,
    [F_EDIT_MODE]: true,
    [F_API_KEY]: true,
    [F_EMAIL_GATE]: true
  }
}

export default API_PLAN
